import { createFileRoute } from '@tanstack/react-router';

import { readWorkOrderName } from '../../features/work-orders/breadcrumb-data';
import { WorkOrderDetailPage } from '../../features/work-orders/work-order-detail-page';

export const Route = createFileRoute('/work-orders/$workOrderId')({
  staticData: {
    // Resolve the work-order name from the cached detail response so the trail
    // reads "Work Orders > {work order}". Returns null until the detail page's
    // query has populated the cache.
    breadcrumb: (match, queryClient) => {
      const { workOrderId } = match.params as { workOrderId: string };
      return readWorkOrderName(queryClient, workOrderId);
    },
    // Deliberately NOT 'full-height'. That layout gives fixed chrome the space
    // it asks for and lets one fill region scroll — which only works while the
    // chrome fits the viewport. Once ENG-773 grew the panel to three sections
    // plus the Reporting Information strip, the chrome outgrew the stack, the
    // fill region collapsed to 0px and the Jobs/Drawings grids mounted into a
    // zero-height box — the tabs looked empty. The page scrolls as a whole
    // instead; each grid bounds its own height. Same call as Job Card Detail.
  },
  component: WorkOrderDetailRoute,
});

function WorkOrderDetailRoute() {
  const { workOrderId } = Route.useParams();
  return <WorkOrderDetailPage workOrderId={workOrderId} />;
}
